import html from "../assets/html.png";
import css from "../assets/css.png";
import js from "../assets/js.png";
import react from "../assets/react.png";
import bootstrap from "../assets/bootstrap.png";
import mui from "../assets/mui.png";
import git from "../assets/git.png";
import github from "../assets/github.png";

export const SkillsData = [
  {
    name: "HTML",
    image: html,
    exp: 2,
  },
  {
    name: "CSS",
    image: css,
    exp: 2,
  },
  {
    name: "JavaScript",
    image: js,
    exp: 2,
  },
  {
    name: "React",
    image: react,
    exp: 1,
  },
  {
    name: "Bootsrap",
    image: bootstrap,
    exp: 2,
  },
  {
    name: "Material UI",
    image: mui,
    exp: 1,
  },
  {
    name: "Git",
    image: git,
    exp: 2,
  },
  {
    name: "GitHub",
    image: github,
    exp: 0.5,
  },
];
